/** Copyright © 2024 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
export const apiWrapper = {
    weatherAPI(url) {
        return `/weather/api/v1/sites${url}`;
    },
    daqApi(url) {
        return `${url}`;
    },
    managerApi(url) {
        return `/manager/apis/v2${url}`;
    },
    stateApi(url) {
        return `/state/apis/v2${url}`;
    },
    controlApi(url) {
        return `/control/apis/v2${url}`;
    },
    authenticationApi(url) {
        return `/authentication/apis/v2${url}`;
    },
    notificationApi(url) {
        return `/notification/apis/v2${url}`;
    },
    alarmApi(url) {
        return `/alarm/apis/v1${url}`;
    },
    managerApisV1(url) {
        return `/manager/apis/v1${url}`;
    },
    managerApiV1(url) {
        return `/manager/api/v1${url}`;
    },
};
export const getApiVersionHeader = (isNew = false) => {
    return {
        'X-API-VERSION': isNew ? '300' : '200',
        'X-API-CHANNEL': 'WEB',
    };
};
